import { rmatchDirSep } from '../matchers/rmatch-dir-sep.js';
import { rmatchSearchParam } from './rmatch-search-param.js';
/**
 * @internal
 */
export function parseURLRoutePattern(pattern, addEntryMatchers) {
    if (!pattern) {
        return [];
    }
    const matchers = [];
    const [pathPattern, queryPattern] = pattern.split('?');
    const parts = pathPattern.split('/');
    for (const part of parts) {
        if (matchers.length) {
            matchers.push(rmatchDirSep);
        }
        if (part) {
            addEntryMatchers(part, matchers);
        }
    }
    new URLSearchParams(queryPattern).forEach((value, param) => {
        matchers.push(rmatchSearchParam(param, value || undefined));
    });
    return matchers;
}
//# sourceMappingURL=url-route-pattern.impl.js.map